import $ from "jquery";
import "slick-carousel";

export default class Carousels {
	constructor(){
		this.carousel = {
            hero: document.querySelectorAll('.carousel[data-carousel="hero"]'),
            blog: document.querySelectorAll('.carousel[data-carousel="blog"]'),
            single_item: document.querySelectorAll('.carousel[data-carousel="single-item"]'),
            single_item_auto: document.querySelectorAll('.carousel[data-carousel="single-item-auto"]'),
			two_items: document.querySelector('.carousel[data-carousel="two-items"]'),
            three_items: document.querySelector('.carousel[data-carousel="three-items"]'),
            four_items: document.querySelector('.carousel[data-carousel="four-items"]'),
            two_rows: document.querySelectorAll('.carousel[data-carousel="two-rows"]'),
            two_rows: document.querySelectorAll('.carousel[data-carousel="two-rows-products"]'),
            articles_wall: document.querySelectorAll('.carousel[data-carousel="wall"'),
		};
	}

	init() {
        if(this.carousel.hero) { this.hero(); }
        if(this.carousel.blog) { this.blog(); }
        if(this.carousel.single_item) { this.singleItem(); }
        if(this.carousel.single_item_auto) { this.singleItemAuto(); }
		if(this.carousel.two_items) { this.twoItems(); }
        if(this.carousel.three_items) { this.threeItems(); }
        if(this.carousel.four_items) { this.fourItems(); }
        if(this.carousel.two_rows) { this.twoRows(); }
        if(this.carousel.two_rows) { this.twoRowsProducst(); }
        if(this.carousel.articles_wall) { this.articlesWall(); }
	}

    hero = () => {
        var carousel = $('.carousel[data-carousel="hero"]');
        
        carousel.each(function(){
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                fade: true,
                arrows: false,
                dots:false,
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: false,
                autoplay: true,
                autoplaySpeed: 3000,
            });
        })
	}

    blog = () => {
        var carousel = $('.carousel[data-carousel="blog"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                dots:false,
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [{
                    breakpoint: 992,
                    settings: 'unslick',
                }]
            });
        })
	}
    
    singleItem = () => {
        var carousel = $('.carousel[data-carousel="single-item"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            // Append Dots only if is not '#hero'
            if($(this).attr('id') != 'hero'){
                $(this).parent().append(arrowsContainer);
            }
            
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
            });
        })
	}

    singleItemAuto = () => {
        var carousel = $('.carousel[data-carousel="single-item-auto"]');
        
        carousel.each(function(){
            var dotsContainer = '<div class="dots-and-arrows"></div>';
            $(this).parent().append(dotsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: false,
                dots:false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2500,
            });
        })
	}

    articlesWall = () => {
        var carousel = $('.carousel[data-carousel="wall"]');
        
        carousel.each(function(){      
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: false,
                dots:false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2500,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1320,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                ],
            });
        })
	}
    
    twoItems = () => {
        var carousel = $('.carousel[data-carousel="two-items"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                dots:false,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [{
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                    }
                }],
            });
        })
    }

    threeItems = () => {
        var carousel = $('.carousel[data-carousel="three-items"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                dots:false,
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                      }
                    },
                    {
                      breakpoint: 769,
                      settings: {
                        slidesToShow: 3,
                      }
                    },
                  ]
            });
        })
    }

    fourItems = () => {
        var carousel = $('.carousel[data-carousel="four-items"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                dots:false,
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                      }
                    },
                    {
                      breakpoint: 769,
                      settings: {
                        slidesToShow: 4,
                      }
                    },
                  ]
            });
        })
    }

    twoRows = () => {
        var carousel = $('.carousel[data-carousel="two-rows"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                dots:false,
                slidesToShow: 3,
                slidesToScroll: 3,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                rows: 2,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [{
                    breakpoint: 414,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                    },
                }],
            });
        })
    }
    twoRowsProducst = () => {
        var carousel = $('.carousel[data-carousel="two-rows-products"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="dots-and-arrows arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: true,
                dots:false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button type="button" class="btn-prev"><i class="bi bi-caret-left-fill"></i></button>',
                nextArrow: '<button type="button" class="btn-next"><i class="bi bi-caret-right-fill"></i></button>',
                appendArrows: $(this).parent().find('.dots-and-arrows.arrows-only'),
                rows: 1,
                infinite: true,
                rewind: true,
                autoplay: false,
                autoplaySpeed: 2500,
                responsive: [{

                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        rows:2
                    },
                }],
            });
        })
    }
}
